'use client';

import { publicEnv } from '@/config';
import type { ImageLoaderProps } from 'next/image';

export default function nextCDNLoader({
  src,
  width,
  quality,
}: ImageLoaderProps): string {
  const cdn = publicEnv.imageCdnUrl?.replace(/\/$/, '');

  const shouldBypassCdn =
    !cdn ||
    src.startsWith('/') ||
    src.startsWith('data:') ||
    src.startsWith('blob:') ||
    /\.svg(?:\?.*)?$/i.test(src);

  if (shouldBypassCdn) {
    return src;
  }

  const resolvedQuality = quality ?? (width <= 640 ? 60 : 75);

  return `${cdn}/_next/image?url=${encodeURIComponent(
    src
  )}&w=${width}&q=${resolvedQuality}&f=webp`;
}
